import { useFlow } from "../../../FlowEdit/useFlow";
import { RenderInputProps } from "../types";
import PromptEditor from "../../../Editor/PromptEditor";
import { useMemo } from "react";
import { FlowNodeTypeEnum } from "@packages/flow-core/module/node/constants";
import { VariableItemType } from "@packages/flow-core/module";

export default function Textarea({ item, moduleId, inputs }: RenderInputProps) {
  const { updateNodeValue, getAllNodes, systemVariables = [] } = useFlow();

  const variables = useMemo(() => {
    const templteVariables =
      getAllNodes()
        .find((node) => node.data.flowType === FlowNodeTypeEnum.templateParam)
        ?.data?.inputs.map((item) => ({
          key: item.key,
          label: item.label,
          isTemplateVariable: true,
        })) || [];
    const globalVariablesModule: Pick<VariableItemType, "key" | "label">[] =
      getAllNodes()
        .find((node) => node.data.flowType === FlowNodeTypeEnum.globalVariable)
        ?.data?.inputs.filter((input) => input.edit)
        .map((item) => ({ key: item.key, label: item.label })) || [];
    const moduleVariablesModule: Pick<VariableItemType, "key" | "label">[] =
      inputs
        ?.filter((input) => input.edit)
        .map((item) => ({
          key: item.key,
          label: item.description || item.label,
          self: true,
        })) || [];

    return [
      ...templteVariables,
      ...globalVariablesModule,
      ...moduleVariablesModule,
      ...systemVariables,
    ];
  }, [getAllNodes, systemVariables, inputs]);

  return (
    <PromptEditor
      title={item.label}
      h={150}
      placeholder={item.placeholder}
      value={item.value as string}
      onChange={(v) => updateNodeValue(moduleId, item.key, v)}
      variables={variables}
    />
  );
}
